import Layout from '../components/layout';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useRouter } from 'next/router';
import styles from '../styles/serverLevels.module.scss';
import ServiceLevelsTable from '../components/serviceLevelsTable';

export default function ServiceLevels() {

  const router = useRouter();
  const { t } = useTranslation('serviceLevels');
  
  return (
    <Layout title={t('title')} lang = {router.locale} route = {router.route} isHeader isFooter>
        <section className = {styles.server_levels}>
            <h3>{t('titles')}</h3>
            <div >
              
              <div>
                <p dangerouslySetInnerHTML = {{__html: t('firstLine', { interpolation: { escapeValue: false }})}} />
              </div>
              <div>
                <p dangerouslySetInnerHTML = {{__html: t('secondLine', { interpolation: { escapeValue: false }})}} />
              </div>
              <div>
                <p dangerouslySetInnerHTML = {{__html: t('thirdLine', { interpolation: { escapeValue: false }})}} />
              </div>
              <div className={styles.wrap_block} >
                <div dangerouslySetInnerHTML = {{__html: t('technicalSupport', { interpolation: { escapeValue: false }})}} />
                <div dangerouslySetInnerHTML = {{__html: t('ongoingDelivery', { interpolation: { escapeValue: false }})}} />
              </div>
              <div>
                <p dangerouslySetInnerHTML = {{__html: t('qualificationRequirements', { interpolation: { escapeValue: false }})}} />
              </div>
              <div>
                <p dangerouslySetInnerHTML = {{__html: t('roles', { interpolation: { escapeValue: false }})}} />
              </div>
              <div className = {styles.table_block}>
                <ServiceLevelsTable />
              </div>
            </div>
        </section>
    </Layout>
  );
};

export const getStaticProps = async ({ locale }) => ({
  props: {
    ...await serverSideTranslations(locale, ['serviceLevels', 'common']),
  },
});
